import { render, staticRenderFns } from "./coupon-sheet.vue?vue&type=template&id=5dcae7b0&scoped=true&lang=html&"
import script from "./coupon-sheet.vue?vue&type=script&lang=js&"
export * from "./coupon-sheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcae7b0",
  null
  
)

export default component.exports